const c = {
  name: "SaudiArabianRiyal",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12.3,17l-0.8-1.4l0,0c-0.2,0.4-0.5,0.8-0.7,1.2l-0.1,0.1c0.5,0.7,0.9,1.5,1.3,2.3c0.1,0.2,0.1,0.4,0.1,0.6
			c0,0.2,0,0.3-0.1,0.5c-0.3,0.8-0.8,1.4-1.5,1.9c-0.7,0.5-1.4,0.8-2.2,0.9c-0.4,0-0.8-0.1-1.2-0.2L7,23.3c0.8,0.5,1.8,0.8,2.7,0.9
			c0.3,0,0.7-0.1,1-0.3c0.3-0.2,0.6-0.4,0.8-0.7c0.8-0.8,1.2-1.8,1.3-2.9V19C12.8,18.3,12.6,17.6,12.3,17z"/>
		<path class="st0" d="M15,17.9h3.2V21H15V17.9z"/>
		<path class="st0" d="M27.4,18.5c-0.2-0.6-0.4-1.1-0.7-1.6l0,0c-0.3,0.4-0.5,0.7-0.7,1.1c0.6,0.9,1,1.9,1.1,2.9
			c-0.3,0.6-0.7,1.1-1.3,1.5c-0.6,0.4-1.2,0.6-1.9,0.6c-0.4,0-0.7,0-1-0.2c-0.3-0.1-0.6-0.3-0.9-0.6c-0.2-0.3-0.4-0.6-0.5-0.9
			c-0.1-0.3-0.2-0.7-0.1-1c0-0.7,0.2-1.4,0.5-2l-0.4-0.2c-0.5,0.9-0.8,1.9-0.8,3c0,0.4,0,0.9,0.1,1.3c0.1,0.4,0.4,0.8,0.7,1.1
			c0.3,0.3,0.6,0.6,1,0.7c0.4,0.2,0.8,0.2,1.2,0.2c0.7,0,1.4-0.2,2.1-0.5s1.1-0.9,1.5-1.5c0.2-0.5,0.3-1.1,0.4-1.6h0.3
			c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.6-0.4,0.8-0.7c0.2,0.2,0.4,0.4,0.6,0.6c0.2,0.1,0.5,0.2,0.8,0.2c0.3,0,0.7-0.2,0.9-0.4
			c0.3-0.2,0.5-0.5,0.6-0.8c0.2-0.4,0.3-0.9,0.3-1.4c0-0.7-0.1-1.3-0.2-2h-0.1c-0.3,0.3-0.6,0.6-0.9,1c0.2,0.6,0.3,1.2,0.3,1.8
			c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5-0.1
			c-0.1-0.1-0.3-0.1-0.4-0.3c-0.1-0.1-0.2-0.2-0.2-0.4c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.4,0-0.7,0.1-1.1v0l-0.6,0.4l-0.3,1
			c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.2,0.3-0.4,0.4c-0.2,0.1-0.5,0.2-0.7,0.2c-0.5,0-0.7-0.4-0.8-0.8C27.5,18.6,27.4,18.5,27.4,18.5
			z"/>
		<path class="st0" d="M8.9,3.4C12.2,1.2,16,0,20,0c5.3,0,10.4,2.1,14.1,5.9S40,14.7,40,20c0,4-1.2,7.8-3.4,11.1
			c-2.2,3.3-5.3,5.9-9,7.4C24,40,20,40.4,16.1,39.6c-3.9-0.8-7.4-2.7-10.2-5.5c-2.8-2.8-4.7-6.4-5.5-10.2C-0.4,20,0,16,1.5,12.3
			C3,8.7,5.6,5.6,8.9,3.4z M10,35c3,2,6.4,3,10,3c4.8,0,9.4-1.9,12.7-5.3c3.4-3.4,5.3-8,5.3-12.7c0-3.6-1.1-7-3-10
			c-2-3-4.8-5.3-8.1-6.6C23.6,2,20,1.7,16.5,2.3C13,3,9.8,4.8,7.3,7.3C4.8,9.8,3,13,2.4,16.5C1.7,20,2,23.6,3.4,26.9S7,33,10,35z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as SaudiArabianRiyal
};
